<section>
    <div class="card mt-1">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h5 class="mb-0 align-self-center">Edit Deadlines</h5>
            </div>
            <div class="d-flex justify-content-end">
                <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
                    <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
                </a>
            </div>
        </div>
        <div class="card-body p-4">
            <div class="basic-details">
                <form class="row g-3" [formGroup] ="prInitiatorForm">
                    <div class="col-md-4">
                        <label class="form-label text-small">Quotation Deadline</label>
                        <input class="form-control form-control-sm" formControlName="siemens_qt_deadline" type="date">
                        <form-feedback [formGroup]="prInitiatorForm" field="siemens_qt_deadline"></form-feedback>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-small">Delivery Deadline</label>
                        <input class="form-control form-control-sm" formControlName="siemens_req_date_deli" type="date">
                        <form-feedback [formGroup]="prInitiatorForm" field="siemens_req_date_deli"></form-feedback>
                    </div>
                </form>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-end">
                <button type="button" [disabled]="!prInitiatorForm.valid" class="btn btn-outline-primary me-2" (click)="updateDeadlines()">Update</button>
            </div>
        </div>
    </div>
</section>